<template>
  <div class="od-container">
    <div class="information">
      <div class="inwrap">
        <div v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data() {
    return {
      content: null,
    };
  },
  mounted() {
    this.$axios.get('/api/privacy')
      .then((res) => {
        this.content = res.data.content;
      });
  },
};
</script>

<style lang="scss" scoped>
  .information {
    .inwrap {
      max-width: 1280px;
      margin: 0 auto;
      padding: 0 50px;
      box-sizing: border-box;

      font-size: 24px;

      h1 {
        padding-top: 80px;
        font-size: 50px;
        font-weight: 700;
        line-height: 1.25em;
        color: #055aaf;
        margin-bottom: 40px;
      }

      h2 {
        font-size: 34px;
        font-weight: 700;
        color: #055aaf;
        margin-top: 30px;
        margin-bottom: 48px;
      }

      p {
        font-size: 28px;
        font-weight: 300;
        color: #0a2438;
      }
    }


  }
</style>
